import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CCNP,
  PRACTICE_TEST as PRACTICE_TEST_CCNP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CCNP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CCNP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CCNP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CCNP,
} from './ccnp'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CCNA,
  PRACTICE_TEST as PRACTICE_TEST_CCNA,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CCNA,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CCNA,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CCNA,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CCNA,
} from './ccna'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";
import { BUNDLE_ARTICLES } from "../content";

export const APP_BUNDLES = [
  {
    title: 'CCNA',
    key: 'ccna',
    description: 'Cisco Certified Network Associate',
    bundle_firebase_collection_name: 'CCNA',
    bundle_id: 1,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  },
  {
    title: 'CCNP',
    key: 'ccnp',
    description: 'Cisco Certified Network Professional',
    bundle_firebase_collection_name: 'CCNP',
    bundle_id: 2,
    THEME_DARK: "#0973ba",
    THEME_LIGHT: "#f79764",
    THEME_BORDER: "#0868a7",
    PREMIUM_BACKGROUND: "#e6f1f8",
    THEME_DARK_MODE: "#1E1F25",
    THEME_LIGHT_DARK_MODE: "#f79764",
    THEME_BORDER_DARK_MODE: "#18191e",
    PREMIUM_BACKGROUND_DARK_MODE: "#1E1F25"
  }
]

export const APP_DATA = {
  SUBSCRIPTION_PLANS: [1, 3, 6, 12],
  ENABLE_PUSH: false,
  DOMAIN_TITLE: 'Topic',
  DISPLAY_APP_NAME: 'CCNA-CCNP CISCO Cert Prep',
  APP_ID: '1574398095'
};

const EXAM_TITLES = {
  'ccna': 'CCNA',
  'ccnp': 'CCNP'
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CCNA';
};

export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CCNA';
};

const APP_NAME = "CISCO";

export const BUNDLE_APP_NAME = "CISCO_BUNDLE";

export const IS_BUNDLE_APP = true;

export const ENABLE_PUSH = false

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'CCNA';
};

export const GET_APP_NAME_FOR_LOGO = (SELECTED_BUNDLE) => {
  const logos = {
    'ccna': '<strong>200-301 CCNA</strong> Exam Prep',
    'ccnp': '<strong>350-401 CCNP</strong> Exam Prep'
  };
  return logos[SELECTED_BUNDLE] || '<strong>Cisco Certification</strong> Prep';
};

const QUESTION_VERSIONS = {
  'ccna': QUESTION_VERSION_OF_JSON_CCNA,
  'ccnp': QUESTION_VERSION_OF_JSON_CCNP
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_CCNA;
};

export let THEME_DARK = '#004A59'
export let THEME_LIGHT = '#43BCCD'
export let THEME_BORDER = '#336E7A'
export let PREMIUM_BACKGROUND = "#ECF6F6"

export let THEME_DARK_MODE = "#1E1F25";
export let THEME_LIGHT_DARK_MODE = "#e1e1e1";
export let THEME_BORDER_DARK_MODE = "#47783A";
export let PREMIUM_BACKGROUND_DARK_MODE = "#1E1F25";

export const app_url = "https://www.learnzapp.com/apps/cisco";

const PRACTICE_TESTS = {
  'ccna': PRACTICE_TEST_CCNA,
  'ccnp': PRACTICE_TEST_CCNP
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_CCNA;
};

const DOMAIN_LISTS = {
  'ccna': APP_DOMAIN_LIST_CCNA,
  'ccnp': APP_DOMAIN_LIST_CCNP
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_CCNA;
};

const STUDY_QUESTION_MENUS = {
  'ccna': GET_STUDY_QUESTION_MENU_CCNA,
  'ccnp': GET_STUDY_QUESTION_MENU_CCNP
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_CCNA;
  let menu = menuFn();

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      icon_bg: '#E6E6FA',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

const FLASH_CARD_MENUS = {
  'ccna': GET_FLASH_CARD_MENU_CCNA,
  'ccnp': GET_FLASH_CARD_MENU_CCNP
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_CCNA;
  return menuFn();
};

const ARTICLE_MENUS = {
  'ccna': GET_ARTICLE_MENU_CCNA,
  'ccnp': GET_ARTICLE_MENU_CCNP
};

export const GET_ARTICLE_MENU = (SELECTED_BUNDLE) => {
  const menuFn = ARTICLE_MENUS[SELECTED_BUNDLE] || GET_ARTICLE_MENU_CCNA;
  let menu = [...menuFn()]; // Create a new array to avoid mutation

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Articles (Testing)',
      icon_bg: '#E6E6FA',
      key: 'all_articles_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

export { BUNDLE_ARTICLES };

/** PROFILE MENU */
export const GET_PROFILE_MENU = () => {
  return [
    {
      title: "App Appearance",
      image: IMAGES?.ic_dark_mode,
    },
    {
      title: "Account Setting",
      image: IMAGES?.ic_account,
    },
    {
      title: "Settings",
      image: IMAGES?.ic_subscription,
    },
    {
      title: "Reset App Data",
      image: IMAGES?.ic_reset,
    },
    {
      title: "Share this app",
      image: IMAGES?.ic_share_app,
    },
    {
      title: "Review App",
      image: IMAGES?.ic_review,
    },
    {
      title: "Other Apps",
      image: IMAGES?.ic_other_app,
    },
    {
      title: "Help and Support",
      image: IMAGES?.ic_help,
    },
  ];
};

/*** LEADING SCREEN TUTORIAL ARRAY ***/
export const GET_TUTORIALS = () => {
  return [
    {
      title: `CCNA-CCNP Exam Prep App`,
      image: IMAGES.slide_1,
      description:
        'Congratulations on choosing the most comprehensive and rigorous Cisco Certification (CCNA and CCNP) test preparation available.',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

export const GET_QUICK_ASSESSMENT = () => {
  return {
    title: "Assessment Test",
    image: IMAGES.quick_assessment,
    description:
      "This assessment test will help us prepare your baseline readiness score.",
  };
};

/** PLAN DETAILS */
export const PREMIUM_PLAN_DETAILS = [
  "Get unlimited access to CCNA and CCNP exam prep, featuring 1,600 realistic test questions with detailed explanations, 400 flashcards, and essential exam tips. Benefit from 800 glossary terms and know your exam readiness with our Readiness Score. Customize your tests or practice with pre-built tests to maximize your success."
];

/** FREE PLANS */
export const FREE_PLAN_DETAILS = [
  "Limited access to a selection of questions and flashcards. Explore the app's features with the free plan before upgrading to premium."
];

/** PLAN DETAILS */
export const PREMIUM_PLAN_DETAILS_SIGNUP = [
  'Unlimited access to CCNA and CCNP Exam Prep',
  '1600 realistic test questions with detailed explanations',
  '400 Flashcards. 800 Glossary Terms.',
  'Monitor your exam readiness with Readiness Score',
]

/** FREE PLANS */
export const FREE_PLAN_DETAILS_SIGNUP = [
  'Limited access to Questions and Flashcards',
  'Try all the app features before buying a premium plan',
  'Know your exam readiness with Readiness Score',
  'Build your custom test or practice on prebuilt test',
  'Exam concept with Flashcards, Glossary and Acronyms',
]

/** PLAN PRICING */
export const PLAN_PRICING = [
  {
    off_percentage: "",
    month_price: "$5",
    bill_price: "$5",
    bill_time: "Monthly",
  },
  {
    off_percentage: "10% Off",
    month_price: "$4",
    bill_price: "$24",
    bill_time: "Quarterly",
  },
  {
    off_percentage: "",
    month_price: "$3",
    bill_price: "$36",
    bill_time: "Annually",
  },
];

/** STRINGS */
export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for CCNA and CCNP certification exams. I think you will find it very useful. Check it out " +
    app_url,
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;

export const PAYWALL_COLUMNS = null;
